import { render } from "./publicNotice.vue?vue&type=template&id=d8ef5bda&scoped=true"
import script from "./publicNotice.vue?vue&type=script&lang=js"
export * from "./publicNotice.vue?vue&type=script&lang=js"

import "./publicNotice.vue?vue&type=style&index=0&id=d8ef5bda&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ef5bda"]])

export default __exports__